<template>
  <v-card wrap>
    <v-card-title
      primary-title
      style="align-items: center; justify-content: space-between"
    >
      <h2>Statistics - By Team</h2>
      <v-select
        style="width: 15%; flex: inherit"
        v-model="selectedSet"
        :items="selector"
      ></v-select>
    </v-card-title>
    <v-container>
      <v-flex d-flex>
        <v-flex style="display: flex" align-center justify-center>
          <strong>{{ teams[statistics[0][0].noTeam].name }}</strong>
          <f-flag :code="statistics[0][0].federationCode" marginLeft="10" marginRight="0"></f-flag>
        </v-flex>

        <v-flex style="display: flex" align-center justify-center>
          <f-flag :code="statistics[0][1].federationCode"></f-flag>
          <strong>{{ teams[statistics[0][1].noTeam].name }}</strong>
        </v-flex>
      </v-flex>

      <f-skill name="spike" header="attack" :buffer="computedBuffer" :statistics-a="teamAStatistics" :statistics-b="teamBStatistics"></f-skill>
      <f-skill name="block" :buffer="computedBuffer" :statistics-a="teamAStatistics" :statistics-b="teamBStatistics"></f-skill>
      <f-skill name="serve" :buffer="computedBuffer" :statistics-a="teamAStatistics" :statistics-b="teamBStatistics"></f-skill>

      <f-row
        name="Opp. Errors"
        color="indigo darken-4"
        :statistics-a="teamAStatistics.opponentErrors"
        :statistics-b="teamBStatistics.opponentErrors"
        :buffer="computedBuffer"
        height="15"
        primary
      ></f-row>

      <f-row
        name="Total"
        color="indigo darken-4"
        :statistics-a="(teamAStatistics[`spikePoint`] || 0) + (teamAStatistics[`blockPoint`] || 0) + (teamAStatistics[`servePoint`] || 0) + (teamAStatistics.opponentErrors || 0)"
        :statistics-b="(teamBStatistics[`spikePoint`] || 0) + (teamBStatistics[`blockPoint`] || 0) + (teamBStatistics[`servePoint`] || 0) + (teamBStatistics.opponentErrors || 0)"
        :buffer="computedBuffer"
        height="15"
        primary
      ></f-row>

    </v-container>
  </v-card>
</template>

<script>
import Flag from '@/components/Flag.vue'
import Row from './Row.vue'
import Skill from './Skill.vue'
import Header from './Header.vue'
import _ from 'lodash'

export default {
  props: ['statistics', 'teams'],

  data: () => ({
    teamA: null,
    teamB: null,
    selectedSet: -1,
    selector: [],
  }),

  components: {
    'f-flag': Flag,
    'f-skill': Skill,
    'f-row': Row,
    'f-header': Header,
  },

  created () {
    this.refreshSetSelector()

    this.teamA = this.statistics[0][0].noTeam
    this.teamB = this.statistics[0][1].noTeam
  },

  watch: {
    statistics () {
      this.refreshSetSelector()
    },
  },

  computed: {
    computedBuffer () {
      if (this.selectedSet === -1) {
        return 200
      }

      return 60
    },

    statisticsFiltered () {
      if (this.selectedSet === -1) {
        return this.computeStatistics(this.statistics)
      }

      return this.statistics[this.selectedSet]
    },

    teamAStatistics () {
      if (this.statisticsFiltered[0].noTeam === this.teamA) {
        return this.statisticsFiltered[0]
      }

      return this.statisticsFiltered[1]
    },

    teamBStatistics () {
      if (this.statisticsFiltered[0].noTeam === this.teamB) {
        return this.statisticsFiltered[0]
      }

      return this.statisticsFiltered[1]
    }
  },

  methods: {
    refreshSetSelector () {
      this.selector = [
        { text: 'All Sets', value: -1 },
        { text: 'Set 1', value: 0 },
      ]

      this.statistics.forEach((set, index) => {
        this.selector.push({ text: `Set ${index + 1}`, value: index })
      })
    },

    computeStatistics (statisticsBySet) {
      const result = [{}, {}]

      for (let set of statisticsBySet) {
        if (set[0].noTeam === this.teamA) {
          _.mergeWith(result[0], set[0], this.merge)
          _.mergeWith(result[1], set[1], this.merge)
        } else {
          _.mergeWith(result[0], set[1], this.merge)
          _.mergeWith(result[1], set[0], this.merge)
        }
      }

      return result
    },

    merge (a, b, key) {
      if (key !== 'noTeam') {
        return (a || 0) + (b || 0)
      }

      return a
    }
  },
}
</script>




// WEBPACK FOOTER //
// src/components/MatchLive/StatisticsByTeam/StatisticsByTeam.vue